import React, { Component } from "react";
import PropTypes from "prop-types";
import { Flex } from "rebass";

import { Currency } from "../../components";

class ComissionTooltip extends Component {
  render() {
    const { active } = this.props;

    if (active) {
      const { payload, label } = this.props;

      return (
        <div style={{ padding: 12, backgroundColor: "rgba(0,0,0,0.1)" }}>
          <p className="label">{`${label}`}</p>
          {payload &&
            payload.map((item, index) => {
              return (
                <Flex
                  key={index}
                  direction={["row"]}
                  justify={["space-between"]}
                  py={[1]}
                  style={{ color: item.stroke }}
                >
                  {item.name} &nbsp;<Currency value={item.value} unit={"Rp"} />
                </Flex>
              );
            })}
        </div>
      );
    }

    return null;
  }
}

ComissionTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string
};

export default ComissionTooltip;



// WEBPACK FOOTER //
// ./src/agency/commissions/ComissionTooltip.js